import { styled } from '@fluentui/react';
import { DataGridBase } from './DataGrid.base';
import { getStyles } from './DataGrid.styles';
import { IDataGridProps, IDataGridStyleProps, IDataGridStyles } from './DataGrid.types';

// Use Fabric Base guidelines since this might be contributed back to Fabric.
export const DataGrid = styled<IDataGridProps, IDataGridStyleProps, IDataGridStyles>(DataGridBase, getStyles, undefined, {
  scope: 'DataGrid',
});
